import { TeamApi } from "@/api";

export async function getCourses(semesterId, activeRole) {
  const { data } = await TeamApi.getCourses(semesterId, activeRole);
  return data;
}

export async function getStudents(semesterId, activeRole) {
  const { data } = await TeamApi.getStudents(semesterId, activeRole);
  return data;
}

export async function getTeachers(semesterId, activeRole) {
  const { data } = await TeamApi.getTeachers(semesterId, activeRole);
  return data;
}
